"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIERRA_EMBED_SRC = exports.OPEN_CHAT_BTN_ANIMATION_DURATION = void 0;
const SIERRA_AGENT_ID = "qY3ctscBlWUktusBnIu4E8WiLKOBWLfQc-ZMZNA0mKQ";
const SIERRA_EMBED_SRC = `https://sierra.chat/agent/${SIERRA_AGENT_ID}/embed`;
exports.SIERRA_EMBED_SRC = SIERRA_EMBED_SRC;
const OPEN_CHAT_BTN_ANIMATION_DURATION = 800;
exports.OPEN_CHAT_BTN_ANIMATION_DURATION = OPEN_CHAT_BTN_ANIMATION_DURATION;